export default __webpack_public_path__ + "media/images/raty/heart-2-bbf60e68001d65e5d3b187fe38eb2185.png";